module.exports = "/assets/packs/images/0951755da20ef10e0f4fb16866d2bfea.png";